import React, { useState } from 'react';
import LaunchDisplay from '../LaunchDisplay';
import ReactHtmlParser from 'react-html-parser';
import { baseUrl } from '../../../../../utils';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

const ProjectorTv = ({ wallData, themeData, sideBarMenu, opentSidebar, setopentSidebar }) => {

    const sideBar = sideBarMenu[0]
    const [activeTab, setactiveTab] = useState(0)
    const [content, setContent] = useState(0)
    return (<>
        <div className="publish_sidebar">
            <Button variant='' onClick={() => setopentSidebar(opentSidebar ? '' : 'open-sidebar')} type="button" className="p-0 publish_toggle_icon" data-factors-form-bind="true" data-factors-click-bind="true">
                <FontAwesomeIcon type={'solid'} icon={'angles-right'} iconClass={''} />
            </Button>
            <div className="publish_sidebar_area">
                <ul className="dashboard-tabs nav flex-wrap p-0 flex-column" role="tablist">
                    {sideBar.map((data, key) => {
                        return (<li className="nav-item d-flex">
                            <a onClick={() => { setactiveTab(key); setContent(key) }} className={`nav-link d-flex flex-grow-1 p-0 flex-column align-items-center ${activeTab == key ? `active` : ''}`} data-bs-toggle="pill" data-bs-target={`#${data.icon}`} data-factors-form-bind="true" data-factors-click-bind="true">
                                <span className="nav-icon w-auto">
                                    <span className="tab-svg-icon">
                                        <img width={data.width} height={data.height} src={baseUrl(`display-logo/${data.icon}.svg`)} />
                                    </span>
                                </span>
                            </a>
                        </li>)
                    })}
                </ul>
            </div>
        </div>
        <div className="full_container">
            <div className="card card-custom mb-3">
                <div className="card-body px-5 display-tabs">
                    <div className="small_container">
                        <div className="tab-content mt-3">

                            {sideBar.map((data, key) => {
                                return (<div className={`tab-pane item-fadeIn ${content == key ? `active show` : ``}`} id={data.icon} role="tabpanel" aria-labelledby={`${data.icon}-tab`}>
                                    <div className="form-group mb-3">
                                        <h4 className="mb-6 font-weight-boldest">{data.heading}</h4>
                                        {data.subTitle ? <p>{data.subTitle}</p> : null}
                                    </div>


                                    <div className="form-group mb-3">
                                        <h5 className="mb-4">Step 1 : {data.Step1} </h5>
                                        <LaunchDisplay themeData={themeData} wallData={wallData} lunch={data.lunch} lunchUrlParm={data.lunchUrlParm} />
                                    </div>

                                    <div className="form-group mb-3">
                                        <h5 className="mb-4">Step 2 :  {data.Step2}</h5>
                                        {ReactHtmlParser(data.content)}
                                    </div>

                                    <p className="d-flex align-items-center flex-wrap mb-2">
                                        Need help?
                                        <a id="tb_vid1" href={`https://vimeo.com/${data.video}`} data-lity className="ms-2 lity_lightbox" data-factors-click-bind="true">
                                            <FontAwesomeIcon type={'light'} icon={'circle-play'} iconClass={'ms-2 text-gray-500'} /> <span className="ms-2">Watch Video</span>
                                        </a>
                                        <span className="d-flex mx-2 text-muted">Or</span>
                                        <a href={`https://taggbox.com/support/${data.linkUrl}`} target="_blank" className="text-underline" data-factors-click-bind="true">Learn More</a>
                                    </p>
                                </div>)
                            })}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>

    )
}

export default ProjectorTv